
import { Component, Vue } from 'vue-property-decorator';
import { Client, ScheduledJobItemModel} from '@/services/api.service';
import { JobType, EnumModel, JobTypeEnums } from '@/common/enumerations';
import * as DateUtils from '@/utilities/date.utils';
import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';

@Component({
  filters: {
    toJobItemType: toJobItemTypeFormatter
  }
})
export default class WidgetCurrentDayJobList extends Vue {

  private jobs: ScheduledJobItemModel[] = [];
  private mounted() {
    // get the scheduled jobs for today

    let dr = new Date();

    // for my sanity, the '+' unary operator converts string to a number
    const fromDate: number = DateUtils.toIsoDate(dr); 
    dr = DateUtils.addDays(dr, 1);
    const toDate: number = fromDate; // DateUtils.toIsoDate(dr); 

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    
    // Set jobtype to 0 (Mixed) for the search
    clientService.getScheduledJobItems(fromDate, toDate, 0).then((data) => {
      this.jobs = data;
    });
  }
}
